import { api, ProjectDetail } from '../api';
import { openModal } from '../components/modal';
import { toast } from '../components/toast';
import { escapeHtml } from '../lib/utils';

export function openEditProjectModal(
  project: ProjectDetail,
  onChanged: () => void
): void {
  openModal(
    `
    <h2 style="font-size:20px;margin-bottom:16px;">Edit project</h2>
    <form id="edit-project-form">
      <div class="field">
        <label>Project name</label>
        <input class="input" name="name" value="${escapeHtml(project.name)}" />
      </div>
      <div class="field">
        <label>What is this project about?</label>
        <textarea class="textarea" name="description" rows="5">${escapeHtml(
          project.description
        )}</textarea>
      </div>
      <div class="field">
        <label>Visibility</label>
        <select class="select" name="visibility">
          <option value="private" ${project.visibility === 'public' ? '' : 'selected'}>Private — only you and members you add can view it</option>
          <option value="public" ${project.visibility === 'public' ? 'selected' : ''}>Public — anyone can view it in read-only mode</option>
        </select>
      </div>
      <div class="form-error hidden" id="edit-error"></div>
      <div style="display:flex;gap:10px;justify-content:flex-end;">
        <button type="button" class="btn btn-ghost" data-close>Cancel</button>
        <button type="submit" class="btn btn-primary">Save changes</button>
      </div>
    </form>
  `,
    (body, close) => {
      const form = body.querySelector('#edit-project-form') as HTMLFormElement;
      const errorEl = body.querySelector('#edit-error') as HTMLElement;
      body.querySelector('[data-close]')!.addEventListener('click', close);

      form.addEventListener('submit', async (e) => {
        e.preventDefault();
        errorEl.classList.add('hidden');
        const data = new FormData(form);
        const name = String(data.get('name') || '').trim();
        if (!name) {
          errorEl.textContent = 'Project name is required';
          errorEl.classList.remove('hidden');
          return;
        }
        try {
          await api.patch(`/projects/${project.id}`, {
            name,
            description: String(data.get('description') || ''),
            visibility: String(data.get('visibility') || 'private'),
          });
          toast('Project updated');
          close();
          onChanged();
        } catch (e: any) {
          errorEl.textContent = e.message || 'Could not update project';
          errorEl.classList.remove('hidden');
        }
      });
    }
  );
}
